// Countdown Bar Timer
class CountdownTimer {
  constructor(element) {
    this.element = element;
    this.mode = element.dataset.countdownMode;
    this.daysElement = element.querySelector('[data-days]');
    this.hoursElement = element.querySelector('[data-hours]');
    this.minutesElement = element.querySelector('[data-minutes]');
    this.secondsElement = element.querySelector('[data-seconds]');
    this.daysUnit = element.querySelector('[data-unit="days"]');
    this.hoursUnit = element.querySelector('[data-unit="hours"]');
    this.minutesUnit = element.querySelector('[data-unit="minutes"]');
    this.secondsUnit = element.querySelector('[data-unit="seconds"]');
    this.sectionWrapper = element.closest('.countdown-bar-section');
    
    this.init();
  }
  
  padZero(num) {
    return num.toString().padStart(2, '0');
  }
  
  getEndOfDayChicago() {
    const now = new Date();
    
    const chicagoFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    
    const parts = chicagoFormatter.formatToParts(now);
    const year = parts.find(p => p.type === 'year').value;
    const month = parts.find(p => p.type === 'month').value;
    const day = parts.find(p => p.type === 'day').value;
    
    const endOfDayString = `${year}-${month}-${day}T23:59:59`;
    const endOfDay = new Date(endOfDayString);
    
    const chicagoOffset = this.getChicagoOffset(now);
    const localOffset = now.getTimezoneOffset();
    const offsetDiff = (localOffset + chicagoOffset) * 60 * 1000;
    
    return new Date(endOfDay.getTime() - offsetDiff);
  }
  
  getChicagoOffset(date) {
    const chicagoFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    
    const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
    const chicagoDate = new Date(date.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
    
    return (chicagoDate.getTime() - utcDate.getTime()) / (1000 * 60);
  }
  
  getSpecificEndDate() {
    const endDate = this.element.dataset.endDate || '';
    const endTime = this.element.dataset.endTime || '23:59';
    
    if (!endDate) {
      return this.getEndOfDayChicago();
    }
    
    const dateTimeString = `${endDate}T${endTime}:00`;
    const targetDate = new Date(dateTimeString);
    
    const chicagoOffset = this.getChicagoOffset(targetDate);
    const localOffset = targetDate.getTimezoneOffset();
    const offsetDiff = (localOffset + chicagoOffset) * 60 * 1000;
    
    return new Date(targetDate.getTime() - offsetDiff);
  }
  
  updateCountdown() {
    const now = new Date();
    let endTime;
    
    if (this.mode === 'daily') {
      endTime = this.getEndOfDayChicago();
    } else {
      endTime = this.getSpecificEndDate();
    }
    
    const timeDiff = endTime - now;
    
    if (timeDiff <= 0) {
      if (this.mode === 'specific') {
        // Hide the entire countdown section when specific date has passed
        if (this.sectionWrapper) {
          this.sectionWrapper.style.display = 'none';
        }
        this.daysElement.textContent = '00';
        this.hoursElement.textContent = '00';
        this.minutesElement.textContent = '00';
      } else {
        this.hoursElement.textContent = '00';
        this.minutesElement.textContent = '00';
        this.secondsElement.textContent = '00';
      }
      
      if (this.mode === 'daily') {
        setTimeout(() => this.updateCountdown(), 1000);
      }
      return;
    }
    
    // Show section if it was hidden (for daily mode reset)
    if (this.sectionWrapper && this.sectionWrapper.style.display === 'none') {
      this.sectionWrapper.style.display = '';
    }
    
    // Show different units based on mode
    if (this.mode === 'specific') {
      // Show Days, Hours, Minutes (hide Seconds)
      this.daysUnit.style.display = 'flex';
      this.secondsUnit.style.display = 'none';
      
      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      
      this.daysElement.textContent = this.padZero(days);
      this.hoursElement.textContent = this.padZero(hours);
      this.minutesElement.textContent = this.padZero(minutes);
    } else {
      // Show Hours, Minutes, Seconds (hide Days)
      this.daysUnit.style.display = 'none';
      this.secondsUnit.style.display = 'flex';
      
      const hours = Math.floor(timeDiff / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
      
      this.hoursElement.textContent = this.padZero(hours);
      this.minutesElement.textContent = this.padZero(minutes);
      this.secondsElement.textContent = this.padZero(seconds);
    }
    
    setTimeout(() => this.updateCountdown(), 1000);
  }
  
  init() {
    this.updateCountdown();
  }
}

// Initialize all countdown timers on the page
document.addEventListener('DOMContentLoaded', () => {
  const countdownTimers = document.querySelectorAll('.countdown-bar__timer');
  countdownTimers.forEach(timer => new CountdownTimer(timer));
});
